import React from 'react';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';
import CollapseButton from 'components/CollapseButton';

import {
	StyledProgramCollapseButtonIcon,
	StyledProgramCollapseButtonText,
	StyledProgramCollapseButtonWrap,
} from './styled';

interface PropsType {
	isCollapsed: boolean;
	onClick: () => void;
}

function ProgramCollapseButton({ isCollapsed, onClick }: PropsType) {
	const { t } = useTranslation();
	return (
		<StyledProgramCollapseButtonWrap onClick={onClick} tabIndex={0} role="button">
			<Grid container alignItems="center" gap="4px">
				<StyledProgramCollapseButtonIcon isCollapsed={isCollapsed} />
				<StyledProgramCollapseButtonText>{t('program.overview')}</StyledProgramCollapseButtonText>
				<CollapseButton
					size="small"
					isCollapsed={isCollapsed}
					collapsedColor={(theme) => theme.palette.primary.main}
				/>
			</Grid>
		</StyledProgramCollapseButtonWrap>
	);
}

export default ProgramCollapseButton;
